import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PromoScreen from 'apps/auth/components/common/Layout/PromoScreen/PromoScreen';
import { TRANSFERS_PROMO_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';

const UsToLacPromo = (props) => {
    useEffect(() => {
        amplitude.getInstance().logEvent(TRANSFERS_PROMO_SCREEN_SHOWN);
    }, []);

    return (
        <PromoScreen
            topButtonCaption={props.promo?.notNowButtonTitle}
            onTopButtonClick={props.onNotNowClick}
            onBottomButtonClick={props.onSendClick}
            onBackButtonClick={props.onBackButtonClick}
            mainImage={props.promo?.mainImgUrl}
            mainImageTopText={props.promo?.mainImageTopText}
            mainImageBottomText={props.promo?.mainImageBottomText}
            rate={props.offerLacText}
            text={props.promo?.offerText}
            bottomButtonCaption={props.promo?.sendButtonTitle}
            variant={'secondary_base'}
            bankLogos={props.promo?.bankLogos}
        />
    );
};

UsToLacPromo.propTypes = {
    promo: PropTypes.object,
    popupFullwidthRef: PropTypes.shape({ current: PropTypes.object }),
};
export default UsToLacPromo;
